<script setup lang="ts">
import { GroupData } from '~/types/groups'

const props = defineProps<{
  group: GroupData
}>()
</script>

<template>
  <div
    class="tw-flex tw-flex-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-bg-gray-100"
  >
    <img
      v-if="props.group.profile_photo_url"
      :src="props.group.profile_photo_url"
      class="tw-h-full tw-w-full tw-object-cover"
    />

    <FontAwesomeIcon v-else icon="image" class="tw-mx-auto tw-my-auto tw-text-2xl" />
  </div>
</template>
